import { render, staticRenderFns } from "./CreatorProfileItsuka.vue?vue&type=template&id=6127dfdc&scoped=true&"
import script from "./CreatorProfileItsuka.vue?vue&type=script&lang=js&"
export * from "./CreatorProfileItsuka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6127dfdc",
  null
  
)

export default component.exports